/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Actions for the container.
 */
import {
  NOTIFY,
  FETCH_DATA,
  FETCH_COMPLETE
} from './types';
import { statuses } from '../../services';

const services = { statuses };

export const fetchData = (service, path, url, params = {}) => {
    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services[service].get(url, params).then(result => {
            if(typeof(result.response) === "undefined"){
              onDataLoaded(dispatch, path, result._embedded.clearenceStatuses);
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

const onDataLoaded = (dispatch, path, value) => {
    dispatch({
        type: FETCH_COMPLETE,
        payload: {op: 'update', path, value }
    });
    return value;
};

const showErrorMessage = (dispatch, message)  => {
  onDataLoaded(dispatch,'notificationColor', "red");
  onDataLoaded(dispatch,'showMessage', message);
  onDataLoaded(dispatch,'showNotification', true);
};

export const saveStatus = (newStatus) => {
  newStatus={
    statusName: newStatus.status.toUpperCase(),
    representation: newStatus.status.toUpperCase(),
    color: newStatus.color
  }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["statuses"].post("clearenceStatuses", newStatus).then(result => {
            if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado una nueva aduana a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'add', path: 'statuses', value: result }});
            }else {
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const editStatus = (newStatus, index) => {

    newStatus={
      ...newStatus,
      statusName: newStatus.representation
    }

    return (dispatch) => {
        dispatch({ type: FETCH_DATA });
        return services["statuses"].put("clearenceStatuses/" + newStatus.id, newStatus, {projection: 'clearenceStatusProjection'}).then(result => {
          if(typeof(result.response) === "undefined"){
              //Cierro modal de formulario
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'update', path: 'formOpen', value: false } });
              //Añado una nueva aduana a la lista del estado
              dispatch({ type: FETCH_COMPLETE, payload: { op: 'updateItem', path: 'statuses', value: {index, value: {...result, id: newStatus.id} }}});
            }else {
              showErrorMessage(dispatch, result.response.data.message)
            }
        });
    };
};

export const notify = (payload) => {
    return {
        type: NOTIFY,
        payload
    };
};



// WEBPACK FOOTER //
// ./containers/status/actions.js